import React, { useState, useEffect, useRef } from "react";
import "./styles/chat.css";
import Call from "./chat/Call";
import axios from "axios";
import Messaging from "./chat/Messaging";
import WebSocketService from "../utils/WebSocketService";
import InitChat from "./chat/InitChat";
import supabase from "../lib/supabase";
import { useNotificationAudio } from "./NotificationAudio";
const wsUrl = process.env.REACT_APP_WS_URL;
const api_url = process.env.REACT_APP_API_URL;
const session_url = api_url + "openai-session";
const openAIUrl = process.env.REACT_APP_OPEN_AI_REAL_TIME_URL;
const secret = process.env.REACT_APP_INTERNAL_API_SECRET;
const n8nUrl = process.env.REACT_APP_N8N_URL;
const IDLE_TIMEOUT = 2 * 60 * 1000; // 2 minutes
const unique_id = localStorage.getItem("unique_id");
const defaultConnection = {
  call: false,
  message: false,
  type: "idle",
  popUp: false,
  connected: false,
};

export default function Chat() {
  const mediaRecorderRef = useRef(null);
  const messagesEndRef = useRef(null);
  // const playNotification = useNotificationAudio();
  const [chatBot, setChatBot] = useState(true);
  const pcRef = useRef(null);
  const intervalRef = useRef(null);
  const [message, setMessage] = useState("");
  const wsRef = useRef(null);
  const timeoutRef = useRef(null);

  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: "ai",
      text: "hello, how may i help on Behalf Developer Imran",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [call, setCall] = useState({
    duration: 0,
    isSpeaking: false,
    volume: 1,
  });
  const [socketMessage, setSocketMessage] = useState(false);
  const [connection, setConnection] = useState(defaultConnection);

  // useEffect(() => {
  //   // const unique_id = localStorage.getItem("unique_id");
  //   if (!unique_id) return; // safety check

  //   // ✅ Create channel
  //   const channel = supabase
  //     .channel(`visitor_messages`)
  //     // .channel(`visitor_${unique_id}`)
  //     .on(
  //       "postgres_changes",
  //       {
  //         event: "INSERT",
  //         schema: "public",
  //         table: "messages",
  //         filter: `visitor_id=neq.${unique_id}`,
  //       },
  //       (payload) => {
  //         console.log("📩 New message for visitor:", payload.new);
  //         setChatBot();
  //         restartInactivityTimer();
  //         setConnection((prev) => ({
  //           ...prev,
  //           connected: true,
  //           type: "message",
  //           popUp: true,
  //           message: true,
  //         }));
  //         let newMessage = {
  //           text: payload.new.content,
  //           id: 2,
  //         };
  //         playNotification();

  //         setMessages((prev) => [...prev, newMessage]);
  //         console.log(messages);
  //       }
  //     )
  //     .subscribe();

  //   console.log(`🔔 Subscribed to visitor_${unique_id} channel`);

  //   // ✅ Cleanup on unmount
  //   return () => {
  //     console.log(`❌ Unsubscribed from visitor_${unique_id}`);
  //     supabase.removeChannel(channel);
  //   };
  // }, []); // empty dependency → only runs once

  const resetConnection = () => {
    console.log("🕒 No activity for 2 minutes — resetting connection");
    setConnection(defaultConnection);
  };
  const restartInactivityTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(resetConnection, IDLE_TIMEOUT);
  };

  // useEffect(() => {
  //   restartInactivityTimer();
  //   return () => clearTimeout(timeoutRef.current);
  // }, []);

  const sendVisitorMessage = async (text) => {
    restartInactivityTimer();
    // const unique_id = localStorage.getItem("unique_id");

    const { data, error } = await supabase.from("messages").insert([
      {
        sender_type: "visitor",
        // visitor_id: visitorId,
        sender_id: unique_id,
        content: text,
      },
    ]);

    if (error) console.error("Error sending:", error);
    else console.log("Message sent:", data);
  };

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NEW_MESSAGE") {
          const newMessage = event.data.payload;
          // Handle in chat (maybe send via WebSocket)
          console.log("Received push message:", newMessage);
          let newMessage1 = {
            content: newMessage.body,
            id: 2,
          };
          setMessages((prev) => [...prev, newMessage1]);
          setConnection((prev) => ({
            ...prev,
            message: true,
            connected: true,
            popUp: true,
          }));
          setSocketMessage(true);
          // Example: send to WebSocket
          // socket.send(JSON.stringify({ type: "NEW_MESSAGE", ...newMessage }));
        }
      });
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    let callActive = connection.connected && connection.type == "call";
    if (callActive) {
      intervalRef.current = setInterval(() => {
        setCall((prev) => ({ ...prev, duration: prev.duration + 1 }));
      }, 1000);
    }
    // } else if (!callActive && intervalRef.current) {
    // } else if (!callActive && intervalRef.current) {
    // clearInterval(intervalRef.current);
    // }

    return () => {
      if (intervalRef.current) {
        // clearInterval(intervalRef.current);
      }
    };
  }, [connection.call, connection.type == "call"]);

  const formatTime = (secs) => {
    const mins = Math.floor(secs / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (secs % 60).toString().padStart(2, "0");
    return `${mins}:${seconds}`;
  };
  const ii = () => {
    setConnection((prev) => ({
      ...prev,
      message: true,
      connected: true,
      type: "message",
      popUp: true,
    }));
  };

  const setupWebSocket = (type = null) => {
    const wsService = WebSocketService.getInstance();
    const ws = wsService.connect(wsUrl);
    // const ws = wsService.connect("ws://localhost:8000");
    wsRef.current = ws;

    ws.onopen = (event) => {
      console.log("connected", event);
      if (type == "messages") {
        setConnection((prev) => ({ ...prev, message: true, type: "message" }));
      } else if (type == "call") {
        setConnection((prev) => ({
          ...prev,
          type: "call",
          call: true,
          connected: true,
        }));
      }
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("Received WebSocket message:", data);

        if (data.type === "in-app-messaging") {
          let audio = new Audio("/assets/message.mp3");
          audio.volume = 1;
          audio.play();
          // scrollToBottom();
          setMessages((prev) => [...prev, { id: 2, text: data.content }]);
          console.log("i should do it ...");
          setLoading(false);
        }

        if (data.type === "in-app-call") {
          speak(data.content);
          console.log("Call data received", event);
        }

        if (data.event === "media" && data.media) {
          setMessages((prev) => [...prev, { id: 2, text: data.media.payload }]);
        }
      } catch (err) {
        console.error("Error parsing WebSocket message:", err);
      }
    };

    ws.onclose = () => {
      console.warn("WebSocket closed");
      setConnection((prev) => ({ ...prev, message: false }));
    };
  };

  useEffect(() => {
    // setupWebSocket();

    return () => {
      // const ws = wsRef.current;
      // console.log(ws);
      // if (ws) {
      //   ws.onmessage = null;
      //   ws.close(); // Optionally close on unmount
      // }
    };
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const speak = (text) => {
    try {
      // const text = "How I may assist you today :)";
      if (!window.speechSynthesis) {
        console.log("speech not supported");
        return;
      }
      setCall((prev) => ({ ...prev, isSpeaking: true }));
      const utterance = new SpeechSynthesisUtterance(text);
      // utterance.lang = "Ur-PK";
      utterance.lang = "ur-PK";
      utterance.volume = call.volume;
      utterance.onerror = () =>
        setCall((prev) => ({ ...prev, isSpeaking: false }));
      utterance.onend = () =>
        setCall((prev) => ({ ...prev, isSpeaking: false }));
      window.speechSynthesis.speak(utterance);
    } catch (error) {
      console.log(error);
    }
  };

  const inAppMessaging = () => {
    setConnection((prev) => ({
      ...prev,
      message: true,
      type: "message",
      connected: true,
    }));
    // return;
    // if (wsRef.current?.readyState == 3) {
    //   setupWebSocket("message");
    // }
  };

  const decreaseVolume = () => {
    if (call.volume > 0 && pcRef.current) {
      let volChange = Math.min(1, +(call.volume - 0.1).toFixed(1));
      pcRef.current.remoteAudioEl.volume = volChange;
      setCall((prev) => ({
        ...prev,
        volume: volChange,
      }));
    }
  };

  const increaseVolume = () => {
    if (call.volume < 1 && pcRef.current) {
      let volChange = Math.min(1, +call.volume.toFixed(1));
      pcRef.current.remoteAudioEl.volume = volChange;
      setCall((prev) => ({
        ...prev,
        volume: volChange,
      }));
    }
  };
  const sendMessage = async () => {
    if (!message) return;
    setLoading(true);

    const userMsgId = Date.now();
    const aiMsgId = userMsgId + 1;

    // Add empty placeholder for AI
    // Add user message immediately
    setMessages((prev) => [...prev, { id: 1, sender: "user", text: message }]);
    setMessage("");

    try {
      if (chatBot) {
        streamFromN8n();
        return;
      }

      if (socketMessage || true) {
        sendVisitorMessage(message);
        console.log("ss");
        return;
      }
      setMessages((prev) => [...prev, { id: aiMsgId, sender: "ai", text: "" }]);

      const response = await fetch(api_url + "chat-reply", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ content: message }),
      });

      if (!response.body) throw new Error("No response body");
      console.log(response.body);

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let fullText = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        if (!chunk.trim()) continue;

        const lines = chunk.split("\n\n");
        for (const line of lines) {
          if (!line.startsWith("data:")) continue;

          const payload = line.replace("data:", "").trim();
          if (payload === "[Done]") continue;

          const cleaned = cleanLLMOutput(payload);
          if (cleaned) {
            // Do not add extra " " here
            fullText += cleaned;
            // fullText = fullText.replace(/\s+/g, " ").trim();

            setMessages((prev) =>
              prev.map((msg) =>
                msg.id === aiMsgId ? { ...msg, text: fullText } : msg
              )
            );
          }
        }
        fullText = fullText.replace(/\s+/g, " ").trim();
      }
    } catch (err) {
      console.error("Stream error", err);
    } finally {
      setLoading(false);
    }
  };

  const streamFromN8n = async () => {
    try {
      setChatBot(true);
      const authString = btoa("imran:password");
      const response = await fetch(n8nUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${authString}`,
        },

        body: JSON.stringify({
          chatInput: message,
          sessionId: unique_id,
          action: "sendMessage",
        }),
      });
      if (!response.ok) {
        throw new Error(`Http Error! status: ${response.status} `);
      }

      //check if response body exists
      if (!response.body) {
        throw new Error("Response body is null");
      }
      const aiMsgId = Date.now() + 1;
      setMessages((prev) => [...prev, { id: aiMsgId, text: "" }]);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let fullText = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        // handle potentials json objects in one chunk
        const chunk = decoder.decode(value, { stream: true });
        // split lines in case multiple JSON objects arrive together
        for (const line of chunk.split("\n").filter(Boolean)) {
          try {
            const event = JSON.parse(line);
            if (event.type === "item") {
              fullText += event.content;
              console.log(fullText);

              // update UI with partial Input here
              setMessages((prev) =>
                prev.map((msg) =>
                  msg.id === aiMsgId ? { ...msg, text: fullText } : msg
                )
              );
              console.log(event.content);
            }
          } catch (error) {
            console.log("Bad JSON chunk", error);
          }
        }
      }
    } catch (error) {
      console.error("streaming failed", error);
    }
  };

  const sendMessagex = async () => {
    if (!message) return;
    setLoading(true);

    try {
      const response = await fetch(api_url + "chat-reply", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ content: message }),
      });

      if (!response.body) throw new Error("No response body");
      const aiMsgId = Date.now() + 1;
      setMessages((prev) => [...prev, { id: aiMsgId, text: "" }]);

      // setMessages((prev) => [...prev, { id: aiMsgId, sender: "ai", text: "" }]);

      setMessages((prev) => [...prev, { id: 1, text: message }]);
      setMessage("");
      setLoading(false);

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let fullText = "";
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        if (chunk.trim()) {
          // server sends lines like "data: ...\n\n"
          const lines = chunk.split("\n\n");
          for (const line of lines) {
            if (line.startsWith("data:")) {
              const payload = line.replace("data:", "").trim();
              if (payload === "[Done]") continue;
              const cleaned = cleanLLMOutput(payload);
              if (cleaned) {
                fullText += payload;
                setMessages((prev) =>
                  prev.map((msg) =>
                    msg.id === aiMsgId ? { ...msg, text: fullText } : msg
                  )
                );
              }
              // setMessages((prev) => [
              //   ...prev, // remove last unfinished message
              //   // ...prev.slice(0, -1), // remove last unfinished message
              //   { id: 2, text: fullText },
              // ]);
            }
          }
        }
      }
    } catch (err) {
      console.error("Stream error", err);
      setLoading(false);
    }
  };

  const cleanLLMOutput = (text) => {
    if (!text) return "";

    return (
      text
        // Remove <think> ... </think> blocks completely
        .replace(/<think>[\s\S]*?<\/think>/g, "")
        // Remove escaped quotes like ""word""
        .replace(/""/g, '"')
        // Trim extra whitespace/newlines
        .trim()
    );
  };
  const closeChat = () => {
    // closeWebSocket();
    if (connection.connected && connection.type == "call") {
      if (pcRef.current) {
        // 1️⃣ Stop local mic stream tracks
        // clear data channel f
        pcRef.current.dataChannels?.forEach((dc) => dc.close());

        pcRef.current.getSenders().forEach((sender) => {
          if (sender.track) {
            sender.track.stop(); // Stops the microphone or camera
          }
        });
        pcRef.current.close();
        // Close DataChannels
        pcRef.current = null;
      }
    }
    WebSocketService.getInstance().close();
    setConnection({
      message: false,
      call: false,
      type: null,
      connected: false,
      popUp: false,
    });
    setCall((prev) => ({ ...prev, duration: 0, loading: false }));
  };

  const inspectRefs = () => {
    console.log(pcRef.current?.getSenders());
    pcRef.current.getSenders().forEach((sender) => {
      if (sender.track) sender.track.stop();
    });
    // console.log(pcRef.current.getTracks());
    console.log(pcRef.current.dataChannels);
  };
  const detectUserSpeaking = async (micStream) => {
    const audioContext = new AudioContext();
    const analyzer = audioContext.createAnalyser();
    const source = audioContext.createMediaStreamSource(micStream);

    source.connect(analyzer);
    analyzer.fftSize = 512;

    const bufferLength = analyzer.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    let speaking = false;
    function checkVolume() {
      analyzer.getByteFrequencyData(dataArray);
      const avgVol = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;

      if (avgVol > 20 && !speaking) {
        //tweak threshold
        speaking = true;
        console.log("user started speaking");
      } else if (avgVol <= 20 && speaking) {
        speaking = false;
      }
      requestAnimationFrame(checkVolume);
    }

    checkVolume();
  };

  const startCall2 = async () => {
    try {
      setConnection((prev) => ({
        ...prev,
        call: true,
        type: "call",
      }));
      const headerLocal = {
        headers: {
          "X-Api-Secret": secret,
          "ngrok-skip-browser-warning": "true",
        },
      };
      const session = await axios
        .get(session_url, headerLocal)
        .then((res) => res.data);
      console.log(session);
      // let session = "";
      pcRef.current = new RTCPeerConnection();

      // set up to play remote audio from the model
      const audioEl = document.createElement("audio");
      audioEl.autoplay = true;
      pcRef.current.remoteAudioEl = audioEl;

      //create a ringing tone player
      const ringTone = new Audio("/assets/interstellar.mp3");
      ringTone.loop = true;
      ringTone.volume = 0.4;
      // ringTone.play().catch((error) => {
      //   console.log(error);
      // });
      const ringtoneTimeout = setTimeout(() => {
        ringTone.play().catch(console.log("error"));
      }, 500);

      let aiAudioStarted = false;

      pcRef.current.ontrack = (event) => {
        clearTimeout(ringtoneTimeout);
        if (!aiAudioStarted) {
          aiAudioStarted = true;
          console.log("ai started stopping ringtone ");
          ringTone.pause();
          ringTone.currentTime = 0;
        }
        console.log(event, "event incoming ...");
        pcRef.current.remoteAudioEl.srcObject = event.streams[0];
      };

      // 4 capture microphone audio
      const micStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      micStream.getTracks().forEach((track) => {
        pcRef.current.addTrack(track, micStream);
      });

      if (connection.connected) {
        detectUserSpeaking(micStream);
      }

      // 5 data channel (optional for sending text)
      const dc = pcRef.current.createDataChannel("oai-events");
      pcRef.current.dataChannel = dc;

      dc.onopen = () => {
        console.log("data channel open ! send greetings");

        dc.send(
          JSON.stringify({
            type: "conversation.item.create",
            role: "assistant",
            content: [{ type: "input_text", text: "Hello, how’s it going " }],
          })
        );
      };

      dc.onmessage = (e) => {
        const data = JSON.parse(e.data);

        switch (data.type) {
          case "output_audio_buffer.started":
            setCall((prev) => ({ ...prev, isSpeaking: true }));
            break;

          case "response.audio_transcript.delta":
            console.log("AI is speaking...");
            setCall((prev) => ({ ...prev, isSpeaking: true }));
            break;

          case "output_audio_buffer.stopped":
            // case "response.audio_transcript.done":
            console.log("AI finished speaking");
            setCall((prev) => ({ ...prev, isSpeaking: false }));
            break;

          case "response.output_text.delta":
            console.log("AI subtitle chunk:", data.text);
            // setSubtitles((prev) => prev + data.text);
            break;

          case "response.output_text.final":
            console.log("Final subtitle:", data.text);
            // setSubtitles(data.text); // or keep appending for a history
            break;

          default:
          // console.log("Other AI event:", data);
        }
      };
      // optional data channel for sending text message

      //6 create SDP offer and send to OPEN AI Realtime API
      const offer = await pcRef.current.createOffer();
      await pcRef.current.setLocalDescription(offer);

      const model = session.model;
      const headers = {
        headers: {
          Authorization: `Bearer ${session.client_secret.value}`,
          "Content-Type": "application/sdp",
        },
      };
      // const body = await pcRef.current.createOffer().sdp;
      const url = `${openAIUrl}?model=${model}`;
      const sdpResponse = await axios.post(url, offer.sdp, headers);

      // 7 set remote description AI's server
      const answer = {
        type: "answer",
        sdp: sdpResponse.data,
      };
      await pcRef.current.setRemoteDescription(answer);
      setConnection((prev) => ({
        ...prev,
        connected: true,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const testCall = async () => {
    try {
      const headers = {
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      };
      const res = await axios.get(
        "https://reliably-powerful-mule.ngrok-free.app",
        headers
      );
      console.log(res.data);
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }
  };
  return (
    <>
      {connection.popUp && (
        <div className="float-chat">
          <div className="chat-container">
            {/* <p onClick={startCall2}>test cll ...</p> */}
            <div className="chat-header">
              <span onClick={streamFromN8n}>AI Robot Chat</span>
              <span onClick={closeChat}>X</span>
              {/* <span onClick={inspectRefs}>X</span> */}
            </div>

            {["message", "call"].includes(connection.type) ? (
              <>
                {connection.type == "message" ? (
                  <Messaging
                    message={message}
                    setMessage={setMessage}
                    messages={messages}
                    sendMessage={sendMessage}
                    messagesEndRef={messagesEndRef}
                    loading={loading}
                  />
                ) : (
                  <div className="chat-body">
                    <div className="chat-messages" id="call">
                      <div className="flex items-center justify-between">
                        <span className="text-md font-semibold">
                          Vol: {(call.volume * 100).toFixed(0)}%
                        </span>
                        <span style={{ textAlign: "center" }}>
                          Call Duration: {formatTime(call.duration)}
                        </span>
                      </div>

                      <div className="control">
                        <button className="icon" onClick={decreaseVolume}>
                          <span className="material-icons-outlined">
                            volume_down
                          </span>
                        </button>

                        <button className="icon" onClick={increaseVolume}>
                          <span className="material-icons-outlined">
                            {" "}
                            volume_up
                          </span>
                        </button>
                      </div>
                      {/* {call.isSpeaking && ( */}
                      {connection.connected ? (
                        <Call call={call} mediaRecorderRef={mediaRecorderRef} />
                      ) : (
                        <div className="loader"></div>
                      )}
                      {/* )} */}
                      <div className="drop-call" onClick={closeChat}>
                        <span className="material-icons-outlined white-icon">
                          call_end
                        </span>
                      </div>
                </div>
                </div>
                )}
              </>
            ) : (
              <>
                <InitChat
                  inAppCall={startCall2}
                  call={call}
                  inAppMessaging={inAppMessaging}
                />
              </>
            )}
          </div>
        </div>
      )}

      <button
        className="top-btn2"
        onClick={() =>
          setConnection((prev) => ({ ...prev, popUp: !connection.popUp }))
        }
      >
          <span className="material-icons-outlined white-icon">smart_toy</span>
        </button>
    </>
  );
}

// curl http://localhost:11434/api/generate -d '{"model":"smollm2", "prompt":"Hello"}'
